import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';
import navbarComponent from '../../vue/marketplace_v2/shared/navbar.vue';

setLanguage();


Vue.prototype.i18n = window.i18n;
Vue.use(TurbolinksAdapter);

if (window.navbarComponent) {
  window.navbarComponent.$destroy(true);
}

window.navbarComponent = new Vue({
  el: '#marketplace-navbar',
  components: { navbarComponent }
});                                                                                                                                                                                                                                               
